var __jsx = React.createElement;
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useIsFocused, useOnUserSelected } from '@pelotoncycle/waffles';
import * as React from 'react';
import { Copy } from '@webtv/copy-provider';
import { focusClass } from '@webtv/global-styles';
import { jsx as _jsx } from "react/jsx-runtime";
export var DeclineButton = function DeclineButton(_ref) {
  var handleClick = _ref.handleClick,
      focusRef = _ref.focusRef,
      dataTestId = _ref.dataTestId;
  var isFocused = useIsFocused();
  useOnUserSelected(handleClick);
  return /*#__PURE__*/_jsx(Decline, {
    className: cx(isFocused && focusClass),
    ref: focusRef,
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsx(Copy, {
      id: "ageGate.decline"
    })
  });
};
var Decline = /*#__PURE__*/styled("div")({
  name: "Decline",
  class: "d1qau7n1"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/age-gate/DeclineButton.linaria.module.css");